import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

let registered = false
let refreshTimer: ReturnType<typeof setTimeout> | undefined

// GSAP and ScrollTrigger for the homepage. Only use these helpers on the client (in onMounted).
export const useStageMotion = () => {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches

  const register = () => {
    if (!registered) {
      gsap.registerPlugin(ScrollTrigger)
      registered = true
    }
    return { gsap, ScrollTrigger }
  }

  // Every section creates its own pins. Once they all exist, put them in page order and measure again.
  const scheduleRefresh = () => {
    clearTimeout(refreshTimer)
    refreshTimer = setTimeout(() => {
      ScrollTrigger.sort()
      ScrollTrigger.refresh()
    }, 60)
  }

  return { prefersReducedMotion, register, scheduleRefresh }
}
